module.exports = __webpack_public_path__ + "img/rock-star.c3afdea1.svg";